import React, { useState } from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle';
// import Rating from '../Rating';

export default function Contact() {
    const [activeTab, setActiveTab] = useState(2);
  const handleTabClick = tabNumber => {
    setActiveTab(tabNumber);
  };
  pageTitle('Testimonial');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/contact/banner_img.png"
        title="Testimonial"
        subTitle="Kindly reach us to get the fastest response and treatment"
      />

       <Section
              topMd={150}
              topLg={140}
              topXl={100}
              bottomMd={200}
              bottomLg={150}
              bottomXl={110}
            >
                <div className="container">
                    <h2 className="cs_section_title cs_fs_72 m-0 text-center">Some Reviews</h2>
            <h5 className="cs_section_subtitle text-uppercase cs_accent_color cs_semibold m-0 cs_fs_32 text-center">Of our clients</h5>
            
      <div className="cs_tabs cs_style1"  data-aos="fade-up"
              data-aos-duration="1200"
              data-aos-offset="200">
            <ul className="cs_tab_links">
              <li className={activeTab === 1 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(1)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/lb.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Mr. Joe</h3>
                      <p className="cs_heading_color mb-0">Lebanon</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className={activeTab === 2 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(2)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/in.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Dr. Khamkar</h3>
                      <p className="cs_heading_color mb-0">India</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className={activeTab === 3 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(3)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/eu.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Dr. Michael</h3>
                      <p className="cs_heading_color mb-0">Europe</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className={activeTab === 4 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(4)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/ca.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Mr. Sam</h3>
                      <p className="cs_heading_color mb-0">Canada</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className={activeTab === 5 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(5)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/au.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Dr. Collins</h3>
                      <p className="cs_heading_color mb-0">Australia</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className={activeTab === 6 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(6)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/in.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Dr. Khandare</h3>
                      <p className="cs_heading_color mb-0">Mumbai</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className={activeTab === 7 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(7)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/in.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Dr. Saurabh Jain</h3>
                      <p className="cs_heading_color mb-0">Bhopal</p>
                    </div>
                  </div>
                </div>
              </li>
              <li className={activeTab === 8 ? 'active' : ''}>
                <div className="cs_tab_link_in" onClick={() => handleTabClick(8)}>
                  <div className="cs_testimonial_1_avatar">
                    <img src="https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/in.svg" alt="Avatar" />
                    <div className="cs_testimonial_1_avatar_right">
                      <h3 className="cs_fs_24 cs_semibold mb-0">Dr. Rishab</h3>
                      <p className="cs_heading_color mb-0">Ratlam</p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <div className="cs_tab_body">
              {activeTab === 1 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                    It has been a pleasure working with Precision Orthocad. The quality of his work is consistently excellent, he always delivers cases quickly, and his customer service is outstanding. He is reliable, professional, and easy to work with. I truly appreciate the great experience I've had working with him and would highly recommend his services.
                  </p>
                  {/* <Rating ratingNumber={4.9} /> */}
                </div>
              )}
              {activeTab === 2 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                   It has been a great experience working with Precision for clear aligner design services. Their treatment setups are consistently accurate, well-planned, and clinically sound, making case reviews efficient and straightforward. Turnaround times are always fast, and the quality of work remains exceptional across every case. The team is responsive, professional, and attentive to feedback, ensuring a smooth workflow from start to finish. I highly appreciate their expertise and dedication to delivering outstanding clear aligner solutions and would highly recommend their services.
                  </p>
                  {/* <Rating ratingNumber={4.0} /> */}
                </div>
              )}
              {activeTab === 3 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                    "We've worked with Precision Orthocad on numerous aligner cases, and the consistency has been impressive. The setups are precise, revisions are handled quickly, and communication is always professional. It's reassuring to have a partner who understands clinical expectations and delivers on time. We look forward to continuing our collaboration."
                  </p>
                  {/* <Rating ratingNumber={4.4} /> */}
                </div>
              )}
              {activeTab === 4 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                  "We've been working with Precision Orthocad for the digital design of Mandibular Advancement Devices (MADS), and the quality has been consistently exceptional. Every design is accurate, well-planned, and delivered within the promised timeline. The team is responsive to feedback, understands our clinical requirements, and makes the revision process smooth and efficient.
                  </p>
                  {/* <Rating ratingNumber={4.0} /> */}
                </div>
              )}
              {activeTab === 5 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                  From single-unit restorations to complex implant and full-arch cases, the team delivers outstanding accuracy, seamless communication, and dependable support. Their professionalism and technical expertise make them far more than a service provider—they are a trusted extension of our laboratory.
We confidently recommend Precision Orthocad to any dental clinic or laboratory seeking world-class Dental CAD solutions."
                  </p>
                  {/* <Rating ratingNumber={4.0} /> */}
                </div>
              )}
               {activeTab === 6 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                   Over the course of our collaboration, Precision Orthocad has consistently demonstrated exceptional expertise in digital orthodontics and implant planning. Their aligner treatment setups are clinically precise, well-structured, and tailored to achieve predictable outcomes, while their surgical guides exhibit outstanding accuracy and fit.
Precision Orthocad has proven to be a dependable digital partner, and I confidently recommend their services to clinicians seeking excellence in aligner planning and guided implant solutions."
                  </p>
                  {/* <Rating ratingNumber={4.0} /> */}
                </div>
              )}
               {activeTab === 7 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                  We've been working with Precision Orthocad for the past three years, and their commitment to quality has never wavered. Every aligner setup is accurate, clinically sound, and delivered on time."
                  </p>
                  {/* <Rating ratingNumber={4.0} /> */}
                </div>
              )}
               {activeTab === 8 && (
                <div className="cs_testimonial cs_style_1">
                  <img src="/images/icons/quote.svg" alt="Icon" />
                  <p>
                  "We've been working with Precision OrthoCAD for our crown & bridge and implant design cases, and the quality has been consistently outstanding. The designs are highly accurate, fit well clinically, and require minimal adjustments, which has significantly improved our workflow. Their team is responsive, delivers on time, and understands our requirements perfectly. I highly recommend their CAD services to any dental practice looking for reliable and precise digital solutions."
                  </p>
                  {/* <Rating ratingNumber={4.0} /> */}
                </div>
              )}
            </div>
          </div>
          </div>
          </Section>
    </>
  );
}
